<template>
  <div class="max-w-content-sm md:max-w-content-xl mx-auto lg:mt-5 mb-10 lg:mb-15">
    <div v-if="loading">
      <p class="text-center py-20">Finding Articles...</p>
    </div>
    <div
      class="p-2.5 sm:px-5 xl:px-0 sm:py-5 sm:grid grid-cols-2 lg:grid-cols-3 sm:auto-rows-fr gap-4"
    >
      <post-preview
        v-for="(post, index) in sortedPosts"
        :key="index"
        class="w-full mb-2.5 md:mb-0"
        :post="post"
      ></post-preview>
    </div>
    <div v-if="!loading && showLoadMore" class="text-center my-5">
      <button class="button min-w-280 md:min-w-360" @click.prevent="loadNextPage">
        View more articles
      </button>
    </div>
    <div v-if="error" class="text-center py-20">
      <p class>{{ error }}</p>
      <button class="button min-w-280 md:min-w-360" @click.prevent="tryAgain">Try again</button>
    </div>
    <div v-if="!loading && posts.length === 0 && noPostsText">
      <p class="my-4 text-center">{{ noPostsText }}</p>
      <p v-if="allPostsUrl" class="my-4 text-center">
        <a :href="allPostsUrl" class="button min-w-280 md:min-w-360">View all articles</a>
      </p>
    </div>
  </div>
</template>

<script>
import PostPreview from './PostPreview.vue';
import Route from '../src/Route';

export default {
  components: { PostPreview },

  props: {
    country: {
      type: String,
    },
    noPostsText: {
      type: String,
      default: null,
    },
    allPostsBtnText: {
      type: String,
      default: null,
    },
    allPostsUrl: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      posts: [],
      perPage: 15,
      currentPage: 1,
      lastPage: null,
      total: null,
      loading: false,
      error: null,
    };
  },

  computed: {
    sortedPosts() {
      return this.posts.sort(function(a, b) {
        return Date.parse(a.publish_at) - Date.parse(b.publish_at);
      });
    },

    showLoadMore() {
      return this.currentPage !== this.lastPage && !this.error;
    },
  },

  created() {
    this.getPosts();
  },

  methods: {
    getPosts() {
      this.loading = true;
      this.error = null;

      axios
        .get(Route('posts.index-json'), {
          params: {
            page: this.currentPage,
            country: this.country,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.posts = [...this.posts, ...response.data.data];
            this.lastPage = response.data.meta.last_page;
            this.currentPage = response.data.meta.current_page;
            this.total = response.data.meta.total;
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          this.error = 'Sorry there was a problem.';
        })
        .then(() => {
          this.loading = false;
        });
    },

    loadNextPage() {
      ++this.currentPage;
      this.getPosts();
    },

    tryAgain() {
      this.getPosts();
    },
  },
};
</script>
